import axios from "axios";

const Api = axios.create({
  baseURL: "https://ms-api.qclass.com.br",
  headers: {
    tokenAgendamentoOnline: "8e5c02a99e26d38bf88350b9e2c89161",
    cpfAluno: "",
    codeCfc: ""
  }
});

export default Api;
